<span
  class="badge"
  [ngClass]="getStatusClass(displayStatus)"
  [ngbPopover]="approvalHierarchy"
  popoverTitle="Approval Status"
  placement="left"
  container="body"
>
  {{ getStatusLabel(displayStatus) }}
</span>

<ng-template #approvalHierarchy>
  <ul class="timeline mt-2 mb-0">
    <li class="timeline-item" *ngFor="let approval of approvals">
      <span
        class="timeline-point timeline-point-indicator"
        [ngClass]="getStatusClass(approval.status)"
      ></span>

      <div class="timeline-event">
        <div class="d-flex justify-content-between mb-1">
          <div>
            <h6 class="mb-0 font-weight-bolder">
              {{ approval.approver?.firstName }}
              {{ approval.approver?.lastName }}
            </h6>

            <small class="text-gray-700">
              {{ approval.approvalDate | date: "EEE MMM dd yyyy, hh:mm a" }}
            </small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap">
          <span class="badge" [ngClass]="getStatusClass(approval.status)">
            {{ getStatusLabel(approval.status) }}
          </span>
        </div>
      </div>
    </li>
  </ul>
</ng-template>
